export const environment = {
  positionApiUrl: '/dev-sasgc-last-position-updater',
  commandApiUrl: '/dev-sasgc-cmd-api',
  commandPlatform: 'MCFAPP'
};
